import { apiService } from './api'

export interface AssetFlowData {
  period: string
  start_date: string
  end_date: string
  total_balance: number
  total_deposits: number
  total_deposits_krw: number
  total_withdrawals: number
  total_withdrawals_krw: number
  total_bonus: number
  total_granted_money?: number
  total_granted_bonus?: number
  // 원화 분리 (2026-08-28 사장님) — 총 보유·당일 지급 원화지갑분
  total_balance_krw?: number
  total_bonus_krw?: number
  total_granted_money_krw?: number
  total_granted_bonus_krw?: number
  total_bulk_grant_money?: number
  net_flow: number
  chart_data: Array<{
    date: string
    deposits: number
    withdrawals: number
    bonus: number
    bulk_grant_money?: number
    net_flow: number
  }>
  updated_at: string
}

export interface HeaderStats {
  deposit_krw: number
  deposit_usdt: number
  withdrawal_krw: number
  withdrawal_usdt: number
  net_krw: number
  net_usdt: number
  today_signups: number
  open_positions: number
  today_traders?: number
  today_visitors?: number
  realtime_members?: number
}

class DashboardService {
  // 헤더 실시간 통계 조회
  async getHeaderStats(): Promise<HeaderStats> {
    const response = await apiService.get('/api/v1/admin/dashboard/header-stats')
    return response.data?.data || response.data || response
  }

  // 자산 흐름 통계 조회
  async getAssetFlow(
    period: 'today' | 'month' | 'custom' = 'today',
    startDate?: string,
    endDate?: string
  ): Promise<AssetFlowData> {
    const params = new URLSearchParams({ period })

    if (period === 'custom' && startDate && endDate) {
      params.append('start_date', startDate)
      params.append('end_date', endDate)
    }

    const response = await apiService.get(`/api/v1/admin/dashboard/asset-flow?${params}`)
    return response.data?.data || response.data || response
  }
}

export const dashboardService = new DashboardService()
export default dashboardService
